import React from 'react'
import AppFrame from '../AppFrame'
import { useQuery } from "@apollo/client"
import { filter, map, find, isEmpty, sortBy } from 'lodash'

import { QUERY_PATIENTS_DATA } from '../data/services/graphqlQueries'
import PageHeader from '../components/PageHeader'
import SectionHeader from '../components/SectionHeader'
import ServiceCard from './Services/ServiceCard'

export default ({globalData, clinic}) => {

  const { loading, error, data } = useQuery(QUERY_PATIENTS_DATA, {
    notifyOnNetworkStatusChange: true,
    variables: { clinic: clinic ? clinic.url : '' },
  });

  if (loading) return null

  const patientsRaw = filter(data.services, (d) => {
    if (clinic) {
      return d.serviceType === 'patients' && d.clinic === clinic.url
    }
  
    return d.serviceType === 'patients' && !d.clinic
  })

  const patients = sortBy(patientsRaw, ['priority'])

  const pageDescription = find(data.pageDescriptions, (pd) => {
    if (clinic) {
      return pd.clinic === clinic.url
    }
  
    return !pd.clinic
  })

  const gridStyles = "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"

  return (
    <AppFrame data={globalData}>
      
      {
        pageDescription !== null &&
        <div className="max-w-6xl mx-auto py-8 px-4">
          <PageHeader title={pageDescription.title} />
          <div className="ecs-text" dangerouslySetInnerHTML={{__html: pageDescription.body }}></div>
        </div>
      }

      {
        patients.length > 0 &&
        <div className="bg-neutral-100 border-b">
          <div className="max-w-6xl mx-auto px-4 py-16 min-h-64 border-top border-bottom border-gray-700 py-8">
            <SectionHeader subtitle={clinic ? clinic.name : 'Eye Clinics of Seattle'} title={'Patients'} theme="black" />
            <div className={gridStyles}>
              {
                map(patients, (p, ndx) => {
                  return (
                    <ServiceCard clinc={clinic} data={p} section="services" theme="dark" key={`patients-${ndx}`} />
                  )
                })
              }
            </div>
           </div>
        </div>
      }
      
    </AppFrame>
  )

}